// extracted by mini-css-extract-plugin
export default {"icon":"VuHRz"};